export enum OrderWorkunitOrigin {
  CATALOG = 'catalog',
  CUSTOM = 'custom',
  QUOTE = 'quote',
}
